import {
  SET_DATA_DAILY_SHARE,
  SET_DATA_RANKING,
  SET_DATA_MONTHLY_SHARE,
  SET_DATA_DAILY_REPORTS
} from '../constants/actionTypes';

/* Utils */
import {
  getDailyShare,
  getRankingChannels,
  getMonthlyShare,
  getDailyReports
} from '../utils/apiAudiences';

export const setDataDailyShare = (dispatch, date = null) =>
  new Promise((resolved, reject) => {
    getDailyShare(date)
      .then(response => {
        dispatch({
          type: SET_DATA_DAILY_SHARE,
          dataDailyShare: response
        });
        resolved(response);
      })
      .catch(error => {
        if (error.code === 404) {
          reject();
        }
        throw error;
      });
  });

export const setDataRanking = (dispatch, date = null) =>
  new Promise((resolved, reject) => {
    getRankingChannels(date)
      .then(response => {
        const dataSorted = response.sort((a, b) => b.miles - a.miles);
        dispatch({
          type: SET_DATA_RANKING,
          dataRanking: dataSorted
        });

        if (response.length) {
          resolved(response);
        } else {
          reject();
        }
      })
      .catch(error => {
        throw error;
      });
  });

export const setDataMonthlyShare = (dispatch, date = null) =>
  new Promise((resolved, reject) => {
    getMonthlyShare(date)
      .then(response => {
        dispatch({
          type: SET_DATA_MONTHLY_SHARE,
          dataMonthlyShare: response
        });

        if (response.length) {
          resolved(response);
        } else {
          reject();
        }
      })
      .catch(error => {
        throw error;
      });
  });

export const setDataDailyReports = (dispatch, date = null) =>
  new Promise((resolved, reject) => {
    getDailyReports(date)
      .then(response => {
        dispatch({
          type: SET_DATA_DAILY_REPORTS,
          dataDailyReports: response
        });

        resolved(response);

        if (response.length) {
          resolved(response);
        } else {
          reject();
        }
      })
      .catch(error => {
        throw error;
      });
  });

export const setCompleteDataAudiences = (dispatch, date = null) => {
  const allData = [
    setDataMonthlyShare(dispatch, date),
    setDataDailyReports(dispatch, date),
    setDataRanking(dispatch, date)
  ];

  return Promise.all(allData)
    .then(data => data)
    .catch(error => {
      throw error;
    });
};
